/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_map.js                                                                             */
/**********************************************************************************************************************/
/* Subscriptions Map */
HafasWebapp.prototype.subscriptions.map = function (_me) {
  // Map Events
  Hafas.ps.sub('/map/markerDragged/' + _me.mapId, Hafas.bind(_me.Controller.Map.locationDrag, _me));
  Hafas.ps.sub('/map/markerDragComplete/' + _me.mapId, Hafas.bind(_me.Controller.Map.locationDragEnd, _me));
  Hafas.ps.sub('/map/openMapViewer', Hafas.bind(_me.Controller.Map.openMapViewer, _me));
  Hafas.ps.sub('/map/openMapViewerForDetails', Hafas.bind(_me.Controller.Map.openMapViewerForDetails, _me));
  Hafas.ps.sub('/map/closeMapViewer', Hafas.bind(_me.Controller.Map.closeMapViewer, _me));
  //Hafas.ps.sub('/map/closeToolbox', Hafas.bind(_me.Controller.Map.closeToolbox, _me));
  Hafas.ps.sub('/map/closeToolboxItem', Hafas.bind(_me.Controller.Map.closeToolboxItem, _me));

  Hafas.ps.sub('/map/toolbox/stationsnear/getStations', Hafas.bind(_me.Controller.Map.toolbox.stationsnear.getStations, _me));
  Hafas.ps.sub('/common/currentPositionActivated/MapLocation', Hafas.bind(_me.Controller.Map.setLocation, _me));

  // Flyout Popover
  Hafas.ps.sub('/map/openPopoverSelection', Hafas.bind(_me.Controller.Map.openPopoverSelection, _me));
  Hafas.ps.sub('/map/closeLocationPopover', Hafas.bind(_me.Controller.Map.closeLocationPopover, _me));
  Hafas.ps.sub('/map/setTPfromPopover', Hafas.bind(_me.Controller.Map.setTPfromPopover, _me));
  Hafas.ps.sub('/map/setTWfromPopover', Hafas.bind(_me.Controller.Map.setTWfromPopover, _me));
  Hafas.ps.sub('/map/setTSfromPopover', Hafas.bind(_me.Controller.Map.setTSfromPopover, _me));

  Hafas.ps.sub('/GUI/map/mobileShow', Hafas.bind(_me.Controller.Map.centerCurrentRoute, _me));
  Hafas.ps.sub('/map/sidedrawer/toggle', Hafas.bind(_me.Controller.Map.sideDrawer.toggle, _me));
  Hafas.ps.sub('/map/sidedrawer/show', Hafas.bind(_me.Controller.Map.sideDrawer.show, _me));
  Hafas.ps.sub('/map/sidedrawer/toggleGeoFeatureHint', Hafas.bind(_me.Controller.Map.sideDrawer.toggleGeoFeatureHint, _me));
  Hafas.ps.sub('/map/sidedrawer/toggleList', Hafas.bind(_me.Controller.Map.sideDrawer.toggleList, _me));
  Hafas.ps.sub('/map/sidedrawer/resize', Hafas.bind(_me.Controller.Map.sideDrawer.resize, _me));
  Hafas.ps.sub('/map/sidedrawer/close', Hafas.bind(_me.Controller.Map.sideDrawer.close, _me));
  Hafas.ps.sub('/map/clickOnLocation', Hafas.bind(_me.Controller.Map.selectLocation, _me));
  Hafas.ps.sub('/map/clickOnLocation/renderLocDetails', Hafas.bind(_me.Controller.Map.renderLocDetails,_me));
  Hafas.ps.sub('/map/clickOnLocation/getLocDetails', Hafas.bind(_me.Controller.Map.getLocDetails, _me));
  Hafas.ps.sub('/tp/centerLocationOnMap', Hafas.bind(_me.Controller.Map.centerLocation, _me));
  Hafas.ps.sub('/tp/centerSectionOnMap', Hafas.bind(_me.Controller.Map.centerSection, _me));
  Hafas.ps.sub('/tp/centerSegment', Hafas.bind(_me.Controller.Map.centerSegment, _me));
  Hafas.ps.sub('/tp/removeHighlightSegment', Hafas.bind(_me.Controller.Map.removeHighlightSegment, _me));
  Hafas.ps.sub('/tp/setLocationValue/webapp', Hafas.bind(_me.Controller.Map.setLocationMarker, _me));
  Hafas.ps.sub('/map/addLocationMarker', Hafas.bind(_me.Controller.Map.setLocationMarker, _me));
  // Add vias on the map
  Hafas.ps.sub('/tp/viaAdded/webapp', Hafas.bind(_me.Controller.Map.setLocationMarker, _me));

  Hafas.ps.sub('/map/clearLocationMarker', Hafas.bind(_me.Controller.Map.clearLocationMarker, _me));
  Hafas.ps.sub("/tp/hoverDetails", Hafas.bind(_me.Controller.Map.hoverDetails, _me));
  Hafas.ps.sub("/tp/unhoverDetails", Hafas.bind(_me.Controller.Map.unhoverDetails, _me));
  Hafas.ps.sub('/map/centerToGeo/webapp', Hafas.bind(_me.Controller.Map.centerToGeo, _me));
  Hafas.ps.sub('/map/select', Hafas.bind(_me.Controller.Map.closeToolbox, _me));
  Hafas.ps.sub('/map/closeToolbox', Hafas.bind(_me.Controller.Map.closeToolbox, _me));
  Hafas.ps.sub('/map/markerDragged', Hafas.bind(_me.Controller.Map.reverseLookUp, _me));
  Hafas.ps.sub('/ui/disableProduct/webapp', Hafas.bind(_me.Controller.Map.disableContent, _me));
  Hafas.ps.sub('/ui/disableMapContent/webapp', Hafas.bind(_me.Controller.Map.disableContent, _me));
  Hafas.ps.sub('/ui/updatedMapContentDisabledStatus/webapp', Hafas.bind(_me.Controller.Map.updateMapContentDisableStatus, _me));
  Hafas.ps.sub('/search/toggleSearch', Hafas.bind(_me.Controller.Map.toggleSearchMode, _me));
  Hafas.ps.sub('/map/showGraph', Hafas.bind(_me.Controller.Map.showGraph, _me));
  Hafas.ps.sub('/map/controlClicked/geoposition', Hafas.bind(function (control, map) {
    _me.Controller.Map.showGeoPosition(map);
  }, _me));

  Hafas.ps.sub('/util/watchingActualPosition', Hafas.bind(_me.Controller.Map.showCurrentPositionMarkerPoint, _me));
  Hafas.ps.sub('/util/stopWatchingActualPosition', Hafas.bind(_me.Controller.Map.hideCurrentPositionMarkerPoint, _me));

  Hafas.ps.sub('/map/createFavoriteMarker', Hafas.bind(_me.Controller.Map.createFavoriteMarker, _me));
  Hafas.ps.sub('/map/removeFavoriteMarker', Hafas.bind(_me.Controller.Map.removeFavoriteMarker, _me));
  Hafas.ps.sub('/map/removeFlyoutLocationMarker', Hafas.bind(_me.Controller.Map.removeFlyoutLocationMarker, _me));

  Hafas.ps.sub('/map/centerToGeo', Hafas.bind(_me.Controller.Map.centerToGeo, _me));
  Hafas.ps.sub('/map/createLocationSelection', Hafas.bind(_me.Controller.Map.createLocationSelection, _me));
  Hafas.ps.sub('/map/setZoom', Hafas.bind(_me.Controller.Map.setZoom, _me));

  Hafas.ps.sub('/map/reverseLookupSuccess/', Hafas.bind(_me.Controller.Map.handleReverseLookupResult, _me));
  Hafas.ps.sub('/map/toggleNetSpider', Hafas.bind(_me.Controller.Map.toggleNetSpider, _me));

  // Drag & Drop
  Hafas.ps.sub('/map/dragDrop/noConnection', Hafas.bind(_me.Controller.Map.showDragNoConnection, _me));
  Hafas.ps.sub('/map/dragDrop/connectionFound', Hafas.bind(_me.Controller.Map.showDragConnectionPreview, _me));
  Hafas.ps.sub('/ui/markerDroppedFromUI/', Hafas.bind(_me.Controller.Map.handleDroppedMarker, _me));


  // Flyout for stations nearby
  Hafas.ps.sub('/map/toolbox/nearStationDetails', Hafas.bind(_me.Controller.Map.showNearStationDetails, _me));
  Hafas.ps.sub('/GUI/sq/toggleNearStations', Hafas.bind(_me.Controller.Map.toggleNearStations, _me));

  // Toggle flyout details
  Hafas.ps.sub('/map/toggleFlyoutDetails', Hafas.bind(_me.Controller.Map.toggleFlyoutDetails, _me));

  // Close flyout
  Hafas.ps.sub("/reachability/loadResultComplete", Hafas.bind(_me.Controller.Map.closeToolbox, _me));
  Hafas.ps.sub('/livemap/popupJourneyBeforeOpen', Hafas.bind(_me.Controller.Map.closeAllToolboxItems, _me));
  Hafas.ps.sub('/map/closeAllToolboxItems', Hafas.bind(_me.Controller.Map.closeAllToolboxItems, _me));
  Hafas.ps.sub('/map/closeFlyout/mapSelection', Hafas.bind(_me.Controller.Map.resetMobilityRadarSelection, _me));

  // Fold in card control elements (relevant for mobile)
  Hafas.ps.sub('/map/leftclick', Hafas.bind(_me.Controller.Map.foldMapControls, _me));
  Hafas.ps.sub('/map/toggleMapControl', Hafas.bind(_me.Controller.Map.closeToolbox, _me));

  // Map flyout: reposition at resize
  Hafas.ps.sub('/app/events/resize', Hafas.bind(_me.Controller.Map.resizeFlyouts, _me));
  // Map flyout: close all mini stationboards
  Hafas.ps.sub('/map/flyout/closeMiniSQ', Hafas.bind(_me.Controller.GUI.sq.closeAllMiniStboard, _me));
  // Map flyout: render external content buttons
  Hafas.ps.sub('/map/renderExternalContentButtons', Hafas.bind(_me.Controller.Map.renderExternalContentButtons, _me));

  // Custom-Buttons
  Hafas.ps.sub('/map/showControl', Hafas.bind(_me.Controller.Map.showControl, _me));

  Hafas.ps.sub('/map/getWeatherInfos', Hafas.bind(_me.Controller.Map.getWeatherInfo, _me));

  Hafas.ps.sub('/map/openWeatherExtended', Hafas.bind(function(){Hafas('#HFS_WeatherInfoExtended').hidden = false;}, _me));
  Hafas.ps.sub('/map/closeWeatherExtended', Hafas.bind(function(){Hafas('#HFS_WeatherInfoExtended').hidden = true;}, _me));

  // Fullscreen-Button
  Hafas.ps.sub('/map/controlClicked/fullscreen', Hafas.bind(_me.Controller.Map.fullscreen.buttonClicked, _me));
  Hafas.ps.sub('/map/controlCreated/fullscreen', Hafas.bind(_me.Controller.Map.fullscreen.buttonCreated, _me));
  Hafas.ps.sub('/GUI/fullscreen/changed', Hafas.bind(_me.Controller.Map.fullscreen.changed, _me));
  Hafas.ps.sub('/map/enableAntiZoomHandling', Hafas.bind(_me.Controller.Map.enablGestureHandling, _me));

  // Open map via sidedrawer menu item
  Hafas.ps.sub('/map/openFromSideDrawer', Hafas.bind(_me.Controller.Map.openFromSidedrawer,_me));

  // Initialize the map base layers
  Hafas.ps.sub('/map/initLayer', Hafas.bind(_me.Controller.Map.initLayer,_me));

  Hafas.ps.sub('/map/showBaseLayerByColorScheme', Hafas.bind(_me.Controller.Map.showBaseLayerByColorScheme,_me));
  Hafas.ps.sub('/GUI/sidedrawerTooltipRerender', Hafas.bind(_me.Controller.Map.sideDrawerTooltipRender,_me));

  // Loading Spinner Top Center of the screen (when new map content is being loaded
  Hafas.ps.sub("/mobilityradar/loadResult", Hafas.bind(_me.Controller.Map.showMapLoadingControl,_me));
  Hafas.ps.sub("/mobilityradar/loadResultComplete", Hafas.bind(_me.Controller.Map.hideMapLoadingControl,_me));

  // connect polyline clicks on map to segment description in details
  Hafas.ps.sub("/map/clickOnPolyline", Hafas.bind(function (secIdx, segIdx, polyS, polyE) {
    if (Hafas.Config.Maps.segmentHighlightingClick) {
      var trigger = Hafas('.lyr_tpRouteDescription[data-seg-id="' + secIdx + '_' + segIdx + '"] button');
      if (Hafas.Util.gui.isVisible(trigger)) Hafas.ps.pub('/tp/centerSegment', [{trigger, secIdx, polyS, polyE}]);
    }
  }, _me));

  // Enable zoom level debug map control
  Hafas.ps.sub('/map/enableZoomLevelDebug', Hafas.bind(_me.Controller.Map.enableZoomLevelDebug,_me));

  // Added observation of layout change from mobile to desktop
  Hafas.ps.sub('/GUI/onLayoutChangeMobileToDesktop', Hafas.bind(_me.Controller.Map.observeLayoutChangeMobileToDesktop, _me));


};
